// eslint-disable-next-line import/no-anonymous-default-export
export default {
  APP_URL: "https://api.acerapps.io/customer-api",
  API_URL: "https://api.acerapps.io/customer-api",
};
// duplicate this file twice and name them "env.prod.ts" and "env.dev.ts"
